import React, { useState } from "react"
import { APIPost } from "../../API"
import { T, TraksConsumer } from "../../traks";
import Dropdown from "../../c/DropDown";
import { TextArea } from "../../c/Input";
import { Loading } from "../../c/Loading";
import { AlertModal } from "../../c/Modals";
import { WhistleStatus } from "../../c/Traks/WhistleStatus";


const Comment = ({ setNewStatus, newStatus, ...props }) => <TextArea placeholder={props.render_static(<T>Add a comment</T>)} onChange={(e) => setNewStatus({ ...newStatus, "comment": e })} />

const ChangeWhistleStatus = ({ whistle, setWhistle = null, setEditStatusOpen, ...props }) => {
    const defaultState = {
        status: whistle["status"],
        action: "change_status",
        access_id: (whistle["whistle_access_id"] || null),
        comment: "",
        company_id: whistle.company_id
    }
    const whistleId = whistle.id
    const [newStatus, setNewStatus] = useState(defaultState)
    const [showLoading, setShowLoading] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [modalText, setModalText] = useState({ type: "", text: "" })
    const whistleStatus = whistle["status"] || whistle["data"]["status"]


    const changeStatus = (newStatus) => {
        setShowLoading(true)
        const accessId = whistleId || null
        APIPost("whistles/" + accessId, newStatus).then(res => {
            setShowLoading(false)
            if (setWhistle)
                setWhistle({ ...whistle, status: res.data.new_status })
            setEditStatusOpen(false)
        }).catch(err => {
            console.log(err)
            setModalText({ type: "error", text: err.response.data })
            setShowLoading(false)
            setShowAlert(true)
        })
    }

    return (<>
        <div className="my-4 mx-4">
            {whistleStatus !== 'closed' && (
                <>
                    <h4>
                        <T>Please pick a new status for the entry</T>
                    </h4>
                    <Dropdown toggleText={WhistleStatus(newStatus.status) || WhistleStatus(whistleStatus)} className="mt-3">
                        <button onClick={() => setNewStatus({ ...newStatus, "status": "processed" })}>
                            <T>Processed</T>
                        </button>
                        <button onClick={() => setNewStatus({ ...newStatus, "status": "passedOn" })}>
                            <T>Passed on</T>
                        </button>
                        <button onClick={() => setNewStatus({ ...newStatus, "status": 'closed' })}>
                            <T>Closed</T>
                        </button>
                    </Dropdown>
                    <div className="mt-5">
                        <TraksConsumer>
                            <Comment setNewStatus={setNewStatus} newStatus={newStatus} />
                        </TraksConsumer>
                    </div>
                    <button
                        className="btn btn_green mt-5 mb-3"
                        disabled={newStatus["status"] === whistle["status"]}
                        onClick={() => changeStatus(newStatus)}
                    >
                        <T>Submit</T>
                    </button>
                </>
            )}
            {whistleStatus === 'closed' && (
                <h4>
                    <T>Since this entry is closed, it cannot be edited</T>
                </h4>
            )}
        </div>
        <Loading
            showLoading={showLoading}
        />
        <AlertModal
            isShowing={showAlert}
            setIsShowing={setShowAlert}
            type={modalText.type}
            text={modalText.text}
        />
    </>);
}

export default ChangeWhistleStatus
